import NavTopStu from '../nav-main/src/v2/nav-top-stu';

/* istanbul ignore next */
NavTopStu.install = function(Vue) {
  Vue.component(NavTopStu.name, NavTopStu);
};

export default NavTopStu;
